import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { LanguageListDataService } from 'src/core/ui/language/language.data';
import { LanguageEditorView } from './language-editor.view';

interface LanguageEditorControllerProps {
	value: string | null;
	mode: ControlMode;
	onChanged: (value: string | null) => void;
	setBusy(isBusy: boolean);
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class LanguageEditorController extends React.Component<LanguageEditorControllerProps, any> {
	protected languageDataService: LanguageListDataService;

	constructor(props) {
		super(props);
		this.languageDataService = LanguageListDataService.make();
	}

	@autobind
	protected languageQuery(q?: string): Promise<QueryResult<LanguageSummary>> {
		return new Promise<QueryResult<LanguageSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.languageDataService.addSorting('languageCode', 'asc', true);
			this.languageDataService.searchKeywords = q;
			this.languageDataService
				.load(query => query)
				.then(res => {
					this.props.setBusy(false);
					resolve({
						items: res,
						totalCount: this.languageDataService.count
					});
				});
		});
	}

	render() {
		return (
			<LanguageEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				languageRequest={{ query: this.languageQuery, dataSet: this.languageDataService }}
				onChanged={this.props.onChanged}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/language/parts/language-editor.controller.tsx